import { render, staticRenderFns } from "./TalentMatrixTableView.vue?vue&type=template&id=c28b623a&scoped=true"
import script from "./TalentMatrixTableView.vue?vue&type=script&lang=js"
export * from "./TalentMatrixTableView.vue?vue&type=script&lang=js"
import style0 from "./TalentMatrixTableView.vue?vue&type=style&index=0&id=c28b623a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28b623a",
  null
  
)

export default component.exports